<template>
  <div id="contact">
    <div class="wrap">
      <popups text="联系我们" submit="hide" @onOff="$emit('onOff', 'con')" type="con">
        <div class="contact-content">
          <div class="email">www.erplus.co</div>
          <div class="address">深圳市龙岗区坂田街道云里智能园6栋304
          </div>
        </div>
      </popups>
    </div>
  </div>
</template>

<script>
import popups from '../popups/popups'

export default {
  name: 'contact',
  components: {
    popups
  },
  props: {
    test: String
  }
}
</script>

<style scoped>
  #contact {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }

  .wrap {
    box-sizing: border-box;
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 1000;
    transform: translate(-50%, -50%);
    width: 580px;
    height: 205px;
    padding: 38px 39px 40px 41px;
    background: #fff;
  }

  .contact-content {
    margin-top: 36px;
    font-size: 18px;
    color: #333333;
    line-height: 36px;
    letter-spacing: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/contact/contact.vue